import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography,
} from '@mui/material';
import { TaskData } from '../../types/task';

interface Props {
  task:      TaskData | null;
  open:      boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel:  () => void;
}

export const TaskDeleteDialog: React.FC<Props> = ({ task, open, isLoading, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>タスクを削除しますか？</DialogTitle>
    <DialogContent>
      <Typography>
        「{task?.title}」を削除します。
        <br />
        この操作は取り消せません。
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={isLoading}>キャンセル</Button>
      <Button onClick={onConfirm} variant="contained" color="error" disabled={isLoading}>
        {isLoading ? '削除中...' : '削除する'}
      </Button>
    </DialogActions>
  </Dialog>
);
